export const OktaInterceptorApplications = [
    'C3 Linear Monitoring',
    'Playout Global Overview'
];
//# sourceMappingURL=okta-interceptor-applications.const.js.map